import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] caught:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-950 px-6" data-testid="error-boundary">
        <div className="max-w-md text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 mb-6 border border-[#d4af37]/40">
            <svg className="w-8 h-8 text-[#d4af37]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
            </svg>
          </div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#d4af37] mb-2">Unexpected Error</p>
          <h1 className="text-3xl font-serif text-stone-50 mb-3">Something broke</h1>
          <p className="text-sm text-stone-500 mb-6">
            We hit a snag rendering this page. Your data is safe — please reload.
          </p>
          <button
            onClick={this.handleReload}
            className="bg-[#d4af37] text-stone-950 hover:bg-[#b5952f] px-6 py-3 uppercase tracking-widest text-xs"
            data-testid="error-reload-btn"
          >
            Reload
          </button>
          {this.state.error?.message && (
            <details className="mt-8 text-left">
              <summary className="text-xs text-stone-600 cursor-pointer">Technical details</summary>
              <pre className="mt-2 text-[11px] text-stone-500 bg-stone-900/60 p-3 overflow-x-auto">
                {String(this.state.error.message)}
              </pre>
            </details>
          )}
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
